import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/40_mountains_lake/40_mountains_lake"
 * Contains 1 texture(s)
 */
export class Mobile40MountainsLakeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/40_mountains_lake/40_mountains_lake';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '40_mountains_lake.jpg'
    ] as const;
}
